import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-fa036fe4")
const _hoisted_1 = { class: "app-layout__navbar" }
const _hoisted_2 = { class: "left" }
_popScopeId()

import { useColors } from "vuestic-ui";
import { useStore } from "vuex";
import { computed } from "vue";
import MainLogo from "@/components/main-logo.vue";
import VaIconMenuCollapsed from "@/components/icons/VaIconMenuCollapsed.vue";
import AppNavbarActions from "@/components/navbar/components/AppNavbarActions.vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();

const { getColors } = useColors();
const colors = computed(() => getColors());

const isSidebarMinimized = computed({
  get: () => store.state.sidebar.isMinimized,
  set: value => store.dispatch("sidebar/setSidebarMinimized", value)
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_va_navbar = _resolveComponent("va-navbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_va_navbar, null, {
      left: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(VaIconMenuCollapsed, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (isSidebarMinimized.value = !_unref(isSidebarMinimized))),
            class: _normalizeClass([{ 'x-flip': _unref(isSidebarMinimized) }, "va-navbar__item"]),
            color: _unref(colors).primary
          }, null, 8, ["class", "color"]),
          _createVNode(_component_router_link, { to: "/" }, {
            default: _withCtx(() => [
              _createVNode(MainLogo, {
                class: "logo",
                height: "40"
              })
            ]),
            _: 1
          })
        ])
      ]),
      right: _withCtx(() => [
        _createVNode(AppNavbarActions, { class: "app-navbar__actions md5 lg4" })
      ]),
      _: 1
    })
  ]))
}
}

})